class Events {
  constructor(options) {
    this.settings = {
      'scrollThrottle': 30,
      'resizeThrottle': 50
    };

    this.scrollSubscribers = [];
    this.scrollListenerAdded = false;
    this.scrollTimeout = null;

    this.resizeSubscribers = [];
    this.resizeListenerAdded = false;
    this.resizeTimeout = null;
  }

  _addScrollListener() {
    var self = this;

    window.addEventListener('scroll', function () {
      self.scrollTimeout = setTimeout(function() {
        clearTimeout(self.scrollTimeout);
        self._notifyScrollSubscribers();
      }, self.settings.scrollThrottle);
    }, false);

    this.scrollListenerAdded = true;
  }

  _addResizeListener() {
    var self = this;

    window.addEventListener('resize', function() {
      self.resizeTimeout = setTimeout(function() {
        clearTimeout(self.resizeTimeout);
        self._notifyResizeSubscribers();
      }, self.settings.resizeThrottle);
    }, true);

    this.resizeListenerAdded = true;
  }

  _getPosition () {
    var doc = document.documentElement,
      left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
      top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    return ({ 'left': left, 'top': top });
  }

  _notifyScrollSubscribers() {
    var i;

    for (i = this.scrollSubscribers.length - 1; i >= 0; i--) {
      this.scrollSubscribers[i](this._getPosition());
    }
  }

  _notifyResizeSubscribers() {
    var i;

    for (i = this.resizeSubscribers.length - 1; i >= 0; i--) {
      this.resizeSubscribers[i]();
    }
  }

  /**
   * Waits for window load or if window has already loaded just completes the promise
   * @return { Promise<boolean>}
   */
  waitForWindowLoad() {
    var self = this;

    return new Promise(function(resolve, reject) {

      // If we have already completed this once
      if(self.windowLoaded) {
        resolve();
      } else {
        switch (document.readyState) {

        // If window is already loaded when first calling this method
        case 'complete':
          self.windowLoaded = true;
          resolve();
          break;
        default:

          // Or wait for the document to complete before proceeding
          if (!self.documentOnReadyStateListenerAdded) {
            document.addEventListener('readystatechange', function() {
              if(document.readyState === 'complete') {
                self.windowLoaded = true;
                resolve();
              }
            });
            self.documentOnReadyStateListenerAdded = true;
          }
          break;
        }
      }
    });
  }

  /**
   * Add subscriber function for scrolling changes
   * @param {function} subscriber callback
   */
  addScrollSubscriber(subscriber) {

    // if there are no existing listeners we need to add scroll listener
    if (!this.scrollListenerAdded) {
      this._addScrollListener();
    }

    if (typeof subscriber === 'function') {
      this.scrollSubscribers.push(subscriber);
    } else {
      throw new Error('Events#addScrollSubscriber: subscriber needs to be a function');
    }
  }

  /**
   * remove subscriber function
   * @param {function} subscriber - subscriber to remove
   */
  removeScrollSubscriber(subscriber) {
    var i;

    for (i = this.scrollSubscribers.length - 1; i >= 0; i--) {
      if (this.scrollSubscribers[i] === subscriber) {
        this.scrollSubscribers.splice(i, 1);
      }
    }
  }

  /**
   * Add subscriber function for scrolling changes
   * @param {function} subscriber callback function
   */
  addResizeSubscriber(subscriber) {

    // if there are no existing listeners we need to add scroll listener
    if (!this.resizeListenerAdded) {
      this._addResizeListener();
    }

    if (typeof subscriber === 'function') {
      this.resizeSubscribers.push(subscriber);
    } else {
      throw new Error('Events#addResizeSubscriber: subscriber needs to be a function');
    }
  }

  /**
   * remove subscriber function
   * @param {function} subscriber - subscriber to remove
   */
  removeResizeSubscriber(subscriber) {
    var i;

    for (i = this.resizeSubscribers.length - 1; i >= 0; i--) {
      if (this.resizeSubscribers[i] === subscriber) {
        this.resizeSubscribers.splice(i, 1);
      }
    }
  }

  /**
   * Triggers resize (not actually, but notifies resize subscribers)
   */
  triggerResize() {
    this._notifyResizeSubscribers();
  }

  /**
   * Triggers scroll (not actually, but notifies scroll subscribers)
   */
  triggerScroll() {
    this._notifyScrollSubscribers();
  }
}

var events = new Events();

export default events;
export { events };
